import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import OneSNavPanel from "@/components/feature/OneSNavPanel";
import { assignedTasks, type TaskItem } from "@/mocks/managerWorkspace";

export default function OperatorWorkspacePage() {
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState<string>("Все");

  const filteredTasks = useMemo(() => {
    if (statusFilter === "Все") return assignedTasks;
    return assignedTasks.filter((t) => t.status === statusFilter);
  }, [statusFilter]);

  const counts = useMemo(() => {
    const all = assignedTasks.length;
    const newCount = assignedTasks.filter((t) => t.status === "Новая").length;
    const inProgress = assignedTasks.filter((t) => t.status === "В работе").length;
    const overdue = assignedTasks.filter((t) => t.status === "Просрочена").length;
    return { all, newCount, inProgress, overdue };
  }, []);

  return (
    <div className="h-screen flex flex-col bg-[#FFF9E6] overflow-hidden"
      style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
    >
      {/* 1C Title Bar */}
      <div className="h-[28px] flex items-center justify-between bg-[#FBED9E] px-3 flex-shrink-0 select-none border-b border-[#D5CA8A]">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5">
            <i className="ri-menu-line text-[#666666] text-[13px]"></i>
            <span className="text-[11px] text-[#2D2D2D] font-medium">Методическая база / Управление торговлей, редакция 11 (1С:Предприятие)</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[11px] text-[#666666]">Оператор Петров А.С.</span>
          <div className="w-px h-3 bg-[#D5CA8A]" />
          <i className="ri-settings-3-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
          <i className="ri-question-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
          <i className="ri-close-line text-[#666666] text-[13px] cursor-pointer hover:text-[#2D2D2D]"></i>
        </div>
      </div>

      {/* 1C Command Bar */}
      <div className="h-[32px] flex items-center gap-1 px-2 bg-[#FFF9E6] border-b border-[#D5CA8A] flex-shrink-0 select-none">
        <div className="flex items-center gap-1">
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-check-line text-[11px]"></i>
            <span>Выполнить</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-arrow-go-back-line text-[11px]"></i>
            <span>Вернуть менеджеру</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1">
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-filter-line text-[11px]"></i>
            <span>Фильтры</span>
          </button>
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-group-line text-[11px]"></i>
            <span>Группировки</span>
          </button>
        </div>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <div className="flex items-center gap-1">
          <button className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
            <i className="ri-printer-line text-[11px]"></i>
            <span>Печать</span>
          </button>
        </div>
        <div className="flex items-center gap-1 ml-auto">
          <button
            onClick={() => navigate("/manager-workspace")}
            className="flex items-center gap-1 px-2 py-[2px] text-[#2D2D2D] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors"
          >
            <i className="ri-user-settings-line text-[10px]"></i>
            <span>Рабочее место менеджера</span>
          </button>
          <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
          <div className="flex items-center gap-1 bg-[#FDF2B5] rounded p-[2px]">
            <span className="px-2 py-[2px] bg-[#E8DB6C] text-[#2D2D2D] rounded text-[11px] font-medium flex items-center gap-1">
              <i className="ri-user-line text-[10px]"></i>
              Рабочее место оператора
            </span>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="h-[32px] flex items-center bg-[#FFF9E6] border-b border-[#D5CA8A] px-1 gap-0 select-none">
        <button className="flex items-center gap-1 px-2 py-1 text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
          <i className="ri-arrow-left-s-line text-[11px]"></i>
        </button>
        <button className="flex items-center gap-1 px-2 py-1 text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer text-[11px] transition-colors">
          <i className="ri-arrow-right-s-line text-[11px]"></i>
        </button>
        <div className="w-px h-4 bg-[#D5CA8A] mx-1" />
        <button
          onClick={() => navigate("/manager-workspace")}
          className="flex items-center gap-1 px-3 py-1 text-[11px] rounded-t cursor-pointer transition-colors border border-b-0 bg-[#FFF9E6] text-[#666666] border-[#FFF9E6] hover:bg-[#FDF2B5]"
        >
          <i className="ri-user-settings-line text-[10px]"></i>
          Рабочее место менеджера
        </button>
        <button className="flex items-center gap-1 px-3 py-1 text-[11px] rounded-t cursor-pointer transition-colors border border-b-0 bg-white text-[#2D2D2D] border-[#D5CA8A] font-medium">
          <i className="ri-user-line text-[10px]"></i>
          Рабочее место оператора
          <i className="ri-close-line text-[10px] hover:text-[#666666] ml-1"></i>
        </button>
        <div className="ml-auto flex items-center gap-1 pr-2 text-[10px]">
          <span className="text-[#666666]">Методическая база</span>
          <span className="text-[#666666]">/</span>
          <span className="text-[#666666]">Управление торговлей</span>
          <span className="text-[#666666]">/</span>
          <span className="text-[#2D2D2D] font-medium">Рабочее место оператора</span>
        </div>
      </div>

      {/* Main area */}
      <div className="flex-1 flex overflow-hidden">
        {/* 1C Navigation Panel */}
        <OneSNavPanel />

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-[16px] font-semibold text-[#2D2D2D]">Рабочее место оператора</h1>
              <p className="text-[11px] text-[#666666]">Задачи, поставленные менеджером</p>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 text-[11px]">
                <span className="text-[#2D2D2D]">
                  Всего задач: <strong>{counts.all}</strong>
                </span>
                <span className="w-px h-3 bg-[#D5CA8A]"></span>
                <span className="text-[#DC2626]">
                  Просрочено: <strong>{counts.overdue}</strong>
                </span>
              </div>
            </div>
          </div>

          {/* Filter pills */}
          <div className="flex items-center gap-2 mb-3">
            <div className="flex items-center bg-[#FDF2B5] rounded px-1 py-1">
              {["Все", "Новые", "В работе", "Просрочены"].map((f) => (
                <button
                  key={f}
                  onClick={() => setStatusFilter(f)}
                  className={`px-2 py-0.5 text-[10px] rounded whitespace-nowrap font-medium transition-colors cursor-pointer ${
                    statusFilter === f
                      ? "bg-white text-[#2D2D2D]"
                      : "text-[#666666] hover:text-[#2D2D2D]"
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>
          </div>

          {/* Task list */}
          <div className="bg-white border border-[#D5CA8A] rounded overflow-hidden">
            {/* Table header */}
            <div className="grid grid-cols-[30px_1fr_150px_90px_160px_100px_110px_90px] gap-2 px-3 py-2 bg-[#FFFDF5] border-b border-[#D5CA8A] text-[10px] font-semibold text-[#666666]">
              <span></span>
              <span>Задача</span>
              <span>Дедлайн</span>
              <span>Приоритет</span>
              <span>Клиент</span>
              <span>Заказ</span>
              <span>Менеджер</span>
              <span>Статус</span>
            </div>

            <div className="max-h-[calc(100vh-240px)] overflow-y-auto">
              {filteredTasks.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-12 text-[#999999]">
                  <i className="ri-inbox-line text-[28px] mb-2"></i>
                  <span className="text-[12px]">Нет задач</span>
                </div>
              ) : (
                filteredTasks.map((task, idx) => (
                  <div
                    key={idx}
                    className="grid grid-cols-[30px_1fr_150px_90px_160px_100px_110px_90px] gap-2 px-3 py-2.5 border-b border-[#E8DB6C]/30 hover:bg-[#FFFDF5] cursor-pointer transition-colors items-center"
                  >
                    {/* Checkbox */}
                    <div className="flex items-center justify-center">
                      <div className="w-4 h-4 rounded border border-[#D5CA8A] hover:border-[#D97706] cursor-pointer flex items-center justify-center bg-white transition-colors">
                        <i className="ri-check-line text-[10px] text-transparent"></i>
                      </div>
                    </div>

                    {/* Task title */}
                    <span className="text-[12px] text-[#2D2D2D] font-medium truncate">
                      {task.title}
                    </span>

                    {/* Deadline */}
                    <span
                      className={`text-[11px] ${
                        task.status === "Просрочена"
                          ? "text-[#DC2626] font-semibold"
                          : "text-[#666666]"
                      }`}
                    >
                      {task.deadline}
                    </span>

                    {/* Priority */}
                    <span>
                      {task.priority === "Высокий" && (
                        <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-[#FEE2E2] text-[#DC2626]">
                          Высокий
                        </span>
                      )}
                      {task.priority === "Средний" && (
                        <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-[#FEF3C7] text-[#D97706]">
                          Средний
                        </span>
                      )}
                      {task.priority === "Низкий" && (
                        <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-[#D4EDDA] text-[#2D6A4F]">
                          Низкий
                        </span>
                      )}
                    </span>

                    {/* Client */}
                    <span className="text-[11px] text-[#666666] truncate">
                      {task.client}
                    </span>

                    {/* Order */}
                    <span className="text-[11px] text-[#666666] truncate font-medium">
                      {task.order || "—"}
                    </span>

                    {/* Manager */}
                    <span className="text-[11px] text-[#666666] truncate">
                      {task.manager || "—"}
                    </span>

                    {/* Status */}
                    <span>
                      {task.status === "Просрочена" && (
                        <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-[#FEE2E2] text-[#DC2626]">
                          Просрочена
                        </span>
                      )}
                      {task.status === "В работе" && (
                        <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-[#FEF3C7] text-[#D97706]">
                          В работе
                        </span>
                      )}
                      {task.status === "Новая" && (
                        <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-[#D4EDDA] text-[#2D6A4F]">
                          Новая
                        </span>
                      )}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Bottom bar */}
          <div className="flex items-center justify-between mt-3 text-[10px] text-[#666666]">
            <span>
              Показано: {filteredTasks.length} из {assignedTasks.length}
            </span>
            <div className="flex items-center gap-1">
              <button className="w-5 h-5 flex items-center justify-center rounded hover:bg-[#FDF2B5] text-[#999999] cursor-pointer">
                <i className="ri-arrow-left-s-line text-[12px]"></i>
              </button>
              <span className="px-1.5 py-0.5 rounded bg-[#FDF2B5] text-[#2D2D2D] font-medium">
                1
              </span>
              <button className="w-5 h-5 flex items-center justify-center rounded hover:bg-[#FDF2B5] text-[#999999] cursor-pointer">
                <i className="ri-arrow-right-s-line text-[12px]"></i>
              </button>
            </div>
          </div>

          {/* Bottom status bar */}
          <div className="h-[24px] flex items-center px-2 mt-3 bg-[#FBED9E] border border-[#D5CA8A] text-[10px] text-[#666666] select-none rounded">
            <span>Последнее обновление: 15.05.2026 | Задач от менеджера: {counts.all} | Новых: {counts.newCount} | В работе: {counts.inProgress} | Просрочено: {counts.overdue}</span>
            <span className="ml-auto">1С:Предприятие 8.3.25.1448</span>
          </div>
        </div>
      </div>
    </div>
  );
}